/* Shopify-only enhancements. Product forms, reviews and cart remain native. */
(() => {
  document.querySelectorAll('a.celovia-language-switcher__button').forEach(link => {
    const update = () => {
      const url = new URL(link.href, location.origin);
      const current = new URLSearchParams(location.search);
      for (const key of ['view', 'variant', 'q', 'type', 'sort_by', 'preview_theme_id']) {
        if (current.has(key)) url.searchParams.set(key, current.get(key));
      }
      link.href = url.pathname + url.search + location.hash;
    };
    update();
    link.addEventListener('click', update);
  });
  document.querySelectorAll('[data-favorites-filter]').forEach(button => {
    button.addEventListener('click', () => {
      const selection = button.closest('.cv-favorites-selection');
      const kind = button.dataset.favoritesFilter;
      selection.querySelectorAll('[data-favorites-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      selection.querySelectorAll('[data-favorites-group]').forEach(group => { group.hidden = kind !== 'all' && group.dataset.favoritesGroup !== kind; });
    });
  });
  document.querySelectorAll('.cv-catalog-menu a, mobile-navigation .mobile-nav__link').forEach(link => {
    link.addEventListener('click', () => link.closest('mobile-navigation')?.querySelector('[data-action="close"]')?.click());
  });
})();
